import { render } from "./SectionsProductsSelect.vue?vue&type=template&id=6915c8b2&scoped=true"
import script from "./SectionsProductsSelect.vue?vue&type=script&lang=js"
export * from "./SectionsProductsSelect.vue?vue&type=script&lang=js"

import "./SectionsProductsSelect.vue?vue&type=style&index=0&id=6915c8b2&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6915c8b2"]])

export default __exports__